import React, { useEffect, useState, useCallback } from 'react';
import { createPortal } from 'react-dom'; // 🆕 ДОБАВИЛИ ЭТО
import { Helmet } from 'react-helmet-async';
import api from './api';
import ChatModal from './ChatModal';

// Карточка таски для заказчика
function CreatedTaskCard({ task, onOpenReport, onCancelTask, onOpenChat, onOpenDispute, isSubmitting }) {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    if (task.status === 'review' && (task.report_created_at || task.report?.created_at)) {
      const timer = setInterval(() => {
        const reportTime = new Date(task.report_created_at || task.report.created_at).getTime();
        const autoApproveDeadline = reportTime + (36 * 60 * 60 * 1000);
        const now = new Date().getTime();
        const distance = autoApproveDeadline - now;

        if (distance < 0) {
          clearInterval(timer);
          setTimeLeft("Время вышло! Принято автоматически");
        } else {
          const h = Math.floor(distance / (1000 * 60 * 60));
          const m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const s = Math.floor((distance % (1000 * 60)) / 1000);
          setTimeLeft(`${h}ч ${m}м ${s}с`);
        }
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [task]);

  const getStatusStyles = (status) => {
    switch(status) {
      case 'open': return { label: 'Поиск исполнителя', className: 'bg-blue-50 text-blue-600 border-blue-100' };
      case 'in_progress': return { label: 'В работе', className: 'bg-indigo-50 text-indigo-600 border-indigo-100' };
      case 'review': return { label: 'На проверке', className: 'bg-amber-50 text-amber-600 border-amber-100 animate-pulse' };
      case 'dispute': return { label: 'В арбитраже', className: 'bg-red-50 text-red-600 border-red-100' };
      case 'done': return { label: 'Выполнено', className: 'bg-emerald-50 text-emerald-600 border-emerald-100' };
      default: return { label: status, className: 'bg-slate-100 text-slate-500 border-slate-200' };
    }
  };

  const statusInfo = getStatusStyles(task.status);
  const rubPrice = task.price_rub || Math.round(task.price * 90);

  return (
    <div className="group p-6 bg-white border border-slate-100 rounded-3xl shadow-[0_4px_20px_rgba(15,23,42,0.015)] hover:shadow-[0_12px_30px_rgba(15,23,42,0.04)] hover:-translate-y-0.5 transition-all duration-300 relative overflow-hidden">
      <div className={`absolute left-0 top-0 bottom-0 w-[4px] transition-colors
        ${task.status === 'review' ? 'bg-amber-500' : 
          task.status === 'in_progress' ? 'bg-indigo-500' :
          task.status === 'dispute' ? 'bg-red-500' :
          task.status === 'done' ? 'bg-emerald-500' : 'bg-blue-400'}`} 
      />

      <div className="flex flex-col sm:flex-row justify-between items-start gap-4 pl-2">
        <div className="flex items-start gap-4">
          <div className={`w-14 h-14 rounded-2xl flex items-center justify-center text-2xl flex-shrink-0 shadow-sm
            ${task.category === 'AI' ? 'bg-purple-50 border border-purple-100/50' : 'bg-blue-50 border border-blue-100/50'}`}>
            {task.category === 'AI' ? '🤖' : '📝'}
          </div>
          <div>
            <h3 className="font-bold text-lg text-slate-900 tracking-tight leading-snug group-hover:text-indigo-600 transition-colors">{task.title}</h3>
            <div className="flex items-baseline gap-2 mt-1.5">
              <span className="text-2xl font-black text-slate-900 tracking-tight">{task.price} USDT</span>
              <span className="text-xs text-slate-400 font-medium">≈ {rubPrice} ₽</span>
            </div>
          </div>
        </div>
        
        <span className={`text-[11px] px-3.5 py-1.5 rounded-full uppercase font-bold tracking-wider border whitespace-nowrap self-start sm:self-center ${statusInfo.className}`}>
          {statusInfo.label}
        </span>
      </div>
      
      <div className="mt-5 ml-2">
        <p className="whitespace-pre-line text-sm text-slate-600 leading-relaxed bg-slate-50/70 p-4 rounded-2xl border border-slate-100/80">{task.description}</p>
      </div>
      
      {task.status === 'open' && (
        <div className="mt-5 ml-2">
          <button disabled={isSubmitting} onClick={() => onCancelTask(task.id)} className="w-full text-xs font-bold py-3.5 text-red-500 bg-red-50/40 hover:bg-red-50 rounded-xl transition border border-red-100/50 active:scale-[0.99] cursor-pointer disabled:opacity-50">
            🚫 Отменить и удалить заказ
          </button>
        </div>
      )}

      {task.status === 'review' && (
        <div className="mt-5 ml-2">
          <div className="text-xs font-mono font-bold text-amber-700 bg-amber-50/80 p-3.5 rounded-xl mb-3 border border-amber-100/60 flex items-center gap-2">
            ⏱️ Автоприемка системы через: <span className="font-black text-amber-600">{timeLeft || "расчет..."}</span>
          </div>
          <button disabled={isSubmitting} onClick={() => onOpenReport(task.id)} className="w-full bg-amber-500 text-white py-3.5 rounded-xl font-semibold hover:bg-amber-600 transition-all shadow-md shadow-amber-100 active:scale-[0.99] flex items-center justify-center gap-2 cursor-pointer disabled:opacity-50">
            📩 Проверить присланную работу
          </button>
        </div>
      )}

      {task.status === 'done' && (
        <div className="mt-5 ml-2">
          <button disabled={isSubmitting} onClick={() => onOpenReport(task.id)} className="w-full bg-slate-100 text-slate-700 py-3.5 rounded-xl font-semibold hover:bg-slate-200 transition-all border border-slate-200/60 active:scale-[0.99] flex items-center justify-center gap-2 text-xs cursor-pointer disabled:opacity-50">
            📋 Посмотреть сданный отчёт и файлы
          </button>
        </div>
      )}

      {(task.status === 'in_progress' || task.status === 'review') && (
        <div className="mt-4 ml-2 flex gap-2">
          <button onClick={() => {
              const execId = task.executor_id || (typeof task.executor === 'object' ? task.executor?.id : task.executor);
              const execUsername = task.executor_username || (typeof task.executor === 'object' ? task.executor?.username : 'исполнителем');
              const tId = task.id || task.task_id;
              const tTitle = task.title || task.name || task.task_title;
              onOpenChat(execId, execUsername, tId, tTitle);
            }} className="flex-1 bg-blue-50 hover:bg-blue-100 text-blue-600 px-4 py-2.5 rounded-xl font-semibold text-xs transition border border-blue-100 flex items-center justify-center gap-1.5 cursor-pointer">
            💬 Чат с исполнителем
          </button>
          <button disabled={isSubmitting} onClick={() => onOpenDispute(task.id)} className="bg-red-50 hover:bg-red-100 text-red-600 px-4 py-2.5 rounded-xl font-semibold text-xs transition border border-red-100 flex items-center justify-center gap-1.5 cursor-pointer disabled:opacity-50" title="Передать спор на рассмотрение арбитражу">
            ⚖️ Открыть спор
          </button>
        </div>
      )}

      <div className="mt-5 pt-4 ml-2 border-t border-slate-100/80 flex flex-col sm:flex-row justify-between sm:items-center gap-2 text-xs font-medium text-slate-400">
        <span className="flex items-center gap-1.5">📁 Категория: <span className="text-slate-700 font-semibold">{task.category === 'AI' ? 'ИИ и Видео' : 'Микро-задачи'}</span></span>
        {task.executor_username ? (
          <div className="flex items-center gap-1">
            <span>Исполнитель:</span>
            <span className="font-bold text-indigo-600 bg-indigo-50 px-2.5 py-0.5 rounded-lg">@{task.executor_username}</span>
          </div>
        ) : (
          <span className="italic text-slate-400 flex items-center gap-1">⏳ Ожидает отклика</span>
        )}
      </div>
    </div>
  );
}

// Основной компонент
function MyCreatedTasks({ refreshTrigger, onTaskStatusChange }) {
  const [tasks, setTasks] = useState([]);
  const [report, setReport] = useState(null);
  const [comment, setComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [activeChat, setActiveChat] = useState(null);

  const [isOpenOpen, setIsOpenOpen] = useState(false);
  const [isOpenReview, setIsOpenReview] = useState(false);
  const [isOpenActive, setIsOpenActive] = useState(false);
  const [isOpenDone, setIsOpenDone] = useState(false);

  const loadMyCreatedTasks = useCallback(() => {
    api.get('tasks/my-created/')
      .then(res => setTasks(res.data))
      .catch(err => console.error("Ошибка загрузки созданных задач", err));
  }, []);

  useEffect(() => { 
    loadMyCreatedTasks(); 
  }, [loadMyCreatedTasks, refreshTrigger]);

  const openReport = async (taskId) => {
    try {
      const res = await api.get(`tasks/${taskId}/report/`);
      setReport({ ...res.data, taskId });
      setComment("");
    } catch (err) { 
      alert("Не удалось загрузить отчет."); 
    }
  };

  const handleTaskStatus = async (taskId, newStatus) => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      if (newStatus === 'done') {
        const response = await api.post(`tasks/${taskId}/complete/`);
        alert(response.data.message || 'Заказ успешно принят, средства переведены исполнителю!');
      } else {
        await api.patch(`tasks/${taskId}/status/`, { status: newStatus, comment: comment });
        alert('Заказ отправлен на доработку исполнителю.');

        // 🆕 Отправляем системное уведомление исполнителю
        const task = tasks.find(t => t.id === taskId);
        const executorId = task?.executor_id || (typeof task?.executor === 'object' ? task.executor?.id : task.executor);
        
        if (executorId) {
          const token = localStorage.getItem('token');
          const commentText = comment ? `\nКомментарий: "${comment}"` : '';
          await fetch(`/api/messages/chat/${executorId}/`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              text: `⚠️ Заказ #${taskId} «${task?.title || ''}» отправлен на доработку.${commentText}`,
              task_id: taskId
            })
          });
        }
      }
      
      setReport(null);
      loadMyCreatedTasks();
      if (onTaskStatusChange) onTaskStatusChange();
    } catch (err) { 
      console.error(err);
      const errorMsg = err.response?.data?.message || err.response?.data?.detail || "Ошибка при обновлении статуса";
      alert(errorMsg); 
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancelTask = async (taskId) => {
    if (isSubmitting) return;
    if (window.confirm("Вы уверены, что хотите удалить этот заказ? Зарезервированная сумма возвратится на ваш баланс.")) {
      setIsSubmitting(true);
      try {
        await api.delete(`tasks/${taskId}/delete/`);
        loadMyCreatedTasks();
        if (onTaskStatusChange) onTaskStatusChange();
      } catch (err) {
        alert("Не удалось отменить заказ. Возможно, его уже кто-то взял.");
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const handleOpenDispute = async (taskId) => {
    if (isSubmitting) return;
    const reason = window.prompt("Укажите причину открытия спора для администратора:");
    if (!reason || !reason.trim()) return;

    setIsSubmitting(true);
    try {
      await api.post(`tasks/${taskId}/dispute/`, { reason });
      const token = localStorage.getItem('token');
      await fetch(`/api/messages/chat/admin100/`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ text: `⚠️ ОТКРЫТ СПОР по задаче #${taskId}!\nПричина: ${reason}`, task_id: taskId })
      });
      alert("Спор открыт! Сообщение отправлено администратору арбитража.");
      loadMyCreatedTasks();
      if (onTaskStatusChange) onTaskStatusChange();
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || err.response?.data?.detail || "Не удалось открыть спор");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOpenChat = (executorId, executorUsername, taskId, taskTitle) => {
    if (!executorId) return;
    setActiveChat({ recipientId: executorId, recipientName: executorUsername, taskId, taskTitle });
  };

  const getFullImageUrl = (imagePath) => {
    if (!imagePath) return '';
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) return imagePath;
    const baseURL = api.defaults.baseURL ? api.defaults.baseURL.replace(/\/api\/?$/, '') : '';
    return `${baseURL}${imagePath.startsWith('/') ? '' : '/'}${imagePath}`;
  };

  const openTasks = tasks.filter(t => t.status === 'open');
  const reviewTasks = tasks.filter(t => t.status === 'review');
  const activeTasks = tasks.filter(t => t.status === 'in_progress');
  const doneTasks = tasks.filter(t => t.status === 'done');
  const currentReportTask = report ? tasks.find(t => t.id === report.taskId) : null;

  const AccordionHeader = ({ title, count, isOpen, onClick, bgStyle, textStyle }) => (
    <button onClick={onClick} className={`flex justify-between items-center w-full py-4 px-5 rounded-2xl mb-3 font-semibold transition-all duration-200 shadow-sm border border-slate-100/40 cursor-pointer ${bgStyle} ${textStyle || ''}`}>
      <div className="flex items-center gap-2.5">
        <span className="uppercase tracking-widest font-bold text-xs">{title}</span>
        <span className={`text-xs px-2 py-0.5 rounded-full font-bold shadow-inner ${count > 0 ? 'bg-white/80' : 'bg-white/40'}`}>{count}</span>
      </div>
      <span className={`text-xs transition-transform duration-300 transform ${isOpen ? 'rotate-180' : ''}`}>▼</span>
    </button>
  );

  return (
    <div className="w-full font-sans text-slate-900 relative">
      <Helmet>
        <title>{currentReportTask ? `Проверка отчета: ${currentReportTask.title} — RealWork.pro` : 'Мои созданные заказы — RealWork.pro'}</title>
      </Helmet>

      <div className="mb-5">
        <AccordionHeader title="Ожидают исполнителя" count={openTasks.length} isOpen={isOpenOpen} onClick={() => setIsOpenOpen(!isOpenOpen)} bgStyle="bg-slate-100/80 hover:bg-slate-200/50" textStyle="text-slate-700" />
        {isOpenOpen && <div className="space-y-4 mt-2 mb-4 animate-in fade-in duration-300">{openTasks.length === 0 ? <p className="text-xs text-slate-400 italic pl-2">Нет заказов в поиске</p> : openTasks.map(t => <CreatedTaskCard key={t.id} task={t} onCancelTask={handleCancelTask} onOpenChat={handleOpenChat} onOpenDispute={handleOpenDispute} isSubmitting={isSubmitting} />)}</div>}
      </div>

      <div className="mb-5">
        <AccordionHeader title="На проверке" count={reviewTasks.length} isOpen={isOpenReview} onClick={() => setIsOpenReview(!isOpenReview)} bgStyle="bg-amber-50 text-amber-800 hover:bg-amber-100/60" />
        {isOpenReview && <div className="space-y-4 mt-2 mb-4 animate-in fade-in duration-300">{reviewTasks.length === 0 ? <p className="text-xs text-slate-400 italic pl-2">Нет отчетов на проверку</p> : reviewTasks.map(t => <CreatedTaskCard key={t.id} task={t} onOpenReport={openReport} onOpenChat={handleOpenChat} onOpenDispute={handleOpenDispute} isSubmitting={isSubmitting} />)}</div>}
      </div>

      <div className="mb-5">
        <AccordionHeader title="В работе у исполнителей" count={activeTasks.length} isOpen={isOpenActive} onClick={() => setIsOpenActive(!isOpenActive)} bgStyle="bg-indigo-50 text-indigo-800 hover:bg-indigo-100/60" />
        {isOpenActive && <div className="space-y-4 mt-2 mb-4 animate-in fade-in duration-300">{activeTasks.length === 0 ? <p className="text-xs text-slate-400 italic pl-2">Нет активных задач в работе</p> : activeTasks.map(t => <CreatedTaskCard key={t.id} task={t} onOpenReport={openReport} onOpenChat={handleOpenChat} onOpenDispute={handleOpenDispute} isSubmitting={isSubmitting} />)}</div>}
      </div>

      <div className="mb-5">
        <AccordionHeader title="Завершенные" count={doneTasks.length} isOpen={isOpenDone} onClick={() => setIsOpenDone(!isOpenDone)} bgStyle="bg-emerald-50 text-emerald-800 hover:bg-emerald-100/60" />
        {isOpenDone && <div className="space-y-4 mt-2 mb-4 animate-in fade-in duration-300">{doneTasks.length === 0 ? <p className="text-xs text-slate-400 italic pl-2">Список завершенных заказов пуст</p> : doneTasks.map(t => <CreatedTaskCard key={t.id} task={t} onOpenReport={openReport} onOpenChat={handleOpenChat} onOpenDispute={handleOpenDispute} isSubmitting={isSubmitting} />)}</div>}
      </div>

      {/* 🆕 МОДАЛКА ЧЕРЕЗ PORTAL (ТЕПЕРЬ ТОЧНО ПО ЦЕНТРУ ЭКРАНА) */}
      {report && createPortal(
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
          <div className="bg-white rounded-3xl shadow-2xl w-full max-w-lg max-h-[90vh] flex flex-col relative animate-in zoom-in-95 duration-200">
            
            <div className="p-6 pb-4 border-b border-slate-100 flex justify-between items-start shrink-0">
              <div>
                <h3 className="font-bold text-xl text-slate-900 tracking-tight">Отчет исполнителя</h3>
                <p className="text-xs text-slate-400 mt-1">Внимательно проверьте результаты</p>
              </div>
              <button onClick={() => setReport(null)} className="text-slate-400 hover:text-slate-700 text-3xl font-bold leading-none cursor-pointer transition-colors p-1">&times;</button>
            </div>
            
            <div className="p-6 overflow-y-auto custom-scroll">
              <div className="whitespace-pre-line bg-slate-50 p-4 rounded-2xl text-sm text-slate-700 border border-slate-100/80 leading-relaxed mb-4">
                {report.text || <span className="italic text-slate-400">Текстовое описание отсутствует</span>}
              </div>

              {report.link && (
                <div className="mb-4">
                  <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Предоставленная ссылка:</label>
                  <a href={report.link.startsWith('http') ? report.link : `https://${report.link}`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-indigo-600 hover:text-indigo-800 font-semibold underline break-all bg-indigo-50/50 px-3 py-2 rounded-xl border border-indigo-100/40 w-full">
                    🔗 {report.link}
                  </a>
                </div>
              )}

              <div className="mb-4">
                <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Прикрепленные скриншоты:</label>
                {report.images && report.images.length > 0 ? (
                  <div className="grid grid-cols-2 gap-2 mt-2">
                    {report.images.map((imgObj) => (
                      <a key={imgObj.id} href={getFullImageUrl(imgObj.image)} target="_blank" rel="noreferrer" className="block overflow-hidden rounded-xl border border-slate-100 hover:opacity-90 transition shadow-sm bg-slate-50">
                        <img src={getFullImageUrl(imgObj.image)} alt="Скриншот" className="w-full h-28 object-cover cursor-zoom-in" />
                      </a>
                    ))}
                  </div>
                ) : report.image ? (
                  <div className="rounded-2xl overflow-hidden border border-slate-100 max-h-48 bg-slate-50 flex items-center justify-center">
                    <img src={getFullImageUrl(report.image)} alt="Скриншот" className="object-contain w-full h-full max-h-48 hover:scale-105 transition duration-300 cursor-zoom-in" onClick={(e) => window.open(e.target.src, '_blank')} />
                  </div>
                ) : (
                  <p className="text-xs text-slate-400 italic">Скриншоты не прикреплены</p>
                )}
              </div>
              
              {tasks.find(t => t.id === report.taskId)?.status !== 'done' && (
                <>
                  <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Направить комментарий (при доработке):</label>
                  <textarea disabled={isSubmitting} className="w-full p-3.5 border border-slate-200 bg-slate-50 rounded-xl text-sm focus:outline-none focus:border-indigo-500 transition resize-none whitespace-pre-wrap" rows="3" placeholder="Опишите, что именно нужно исправить..." value={comment} onChange={(e) => setComment(e.target.value)} />
                </>
              )}
            </div>

            <div className="p-6 border-t border-slate-100 bg-white shrink-0">
              {tasks.find(t => t.id === report.taskId)?.status !== 'done' ? (
                <div className="flex flex-col sm:flex-row gap-3">
                  <button disabled={isSubmitting} onClick={() => setReport(null)} className="py-3.5 px-5 bg-slate-100 text-slate-600 rounded-xl font-semibold hover:bg-slate-200 transition text-sm order-3 sm:order-1 active:scale-[0.99] cursor-pointer disabled:opacity-50">Закрыть</button>
                  <button disabled={isSubmitting} onClick={() => handleTaskStatus(report.taskId, 'in_progress')} className="flex-1 bg-amber-500 text-white py-3.5 rounded-xl font-semibold hover:bg-amber-600 transition text-sm order-2 shadow-lg shadow-amber-100 active:scale-[0.99] cursor-pointer disabled:opacity-50">На доработку</button>
                  <button disabled={isSubmitting} onClick={() => handleTaskStatus(report.taskId, 'done')} className="flex-1 bg-emerald-500 text-white py-3.5 rounded-xl font-semibold hover:bg-emerald-600 transition text-sm order-1 sm:order-3 shadow-lg shadow-emerald-100 active:scale-[0.99] flex items-center justify-center gap-2 cursor-pointer disabled:opacity-50">
                    {isSubmitting ? 'Обработка...' : 'Принять работу'}
                  </button>
                </div>
              ) : (
                <button onClick={() => setReport(null)} className="w-full py-3.5 bg-slate-100 text-slate-600 rounded-xl font-semibold hover:bg-slate-200 transition text-sm active:scale-[0.99] cursor-pointer">Закрыть архивный отчёт</button>
              )}
            </div>

          </div>
        </div>,
        document.body // 🆕 Рендерим прямо в body, игнорируя родительские стили
      )}

      {activeChat && (
        <ChatModal recipientId={activeChat.recipientId} recipientName={activeChat.recipientName} taskId={activeChat.taskId} taskTitle={activeChat.taskTitle} onClose={() => setActiveChat(null)} />
      )}
    </div>
  );
}

export default MyCreatedTasks;